export const ButtonInsert = () => {
    const uri = window.location.href;
    const entity = uri.slice(uri.lastIndexOf('/')+1, uri.length)
    return (
        <div className="button-insert">
            <a className="button" href={`/admin/entity/insert/${entity}`} alt="insert">Insert</a>
        </div>
    )
}